import { LoadingButton } from '@mui/lab'
import { Typography } from '@mui/material'
import React from 'react'
import { useAuthContext } from 'src/auth/useAuthContext'
import CustomModal from 'src/components/customerinput/CustomModal'
import deleteCampianAssignGroup from 'src/services/campian/deleteAssignGroup'
import deleteCampianGroup from 'src/services/campian/deleteGroup'

export default function DeleteModal({ open, close, setReload, editData ,type}) {
    const { user } = useAuthContext()
    const handleSubmit = async () => {
        let data;
        if (type == 'group') {
            data = await deleteCampianGroup(user, editData?._id)
        }else{
            data = await deleteCampianAssignGroup(user, editData?._id)
        }
        if (data) {
            setReload((prev) => !prev)
            close()
        }
    }
    return (
        <div>
            <CustomModal open={open} close={close} heading="Delete" action={<LoadingButton variant="contained" onClick={handleSubmit}>Confirm</LoadingButton>}>
                <Typography>Are you sure you want to delete?</Typography>
            </CustomModal>
        </div>
    )
}
